
import React from 'react';
import { useLocation } from 'react-router-dom';
import Routess from './Components/Main/Routess';
import Navbar from './Components/Main/Navbar';
import Footer from "./Components/Main/Footer"
import AdminDashboard from './Components/Admin/Admindashboard/Admindashboard';
// import ProtectedRoute from './Components/Main/ProtectedRoute';



const App = () => {
  const location = useLocation(); // Get the current location

  // Debugging location
  // console.log('Current location:', location.pathname);

  const restrictedPaths = [

      "/login",
      "/admin/dashboard",
      "/admin/addstaffform",
      "/admin/managestaff",
      "/admin/committeeform",
      "/admin/managecommittee",
      "/admin/addeventform",
      "/admin/manageevents",
      "/admin/addhostel",
      "/admin/managehostel",
      "/admin/addtenderform",
      "/admin/managetenders", // Add more restricted paths here if needed
      "/admin/gallerymanagement",
      "/admin/addmou",
      "/admin/managemou",
      "/admin/addV&Mmom",
      "/admin/manageV&Mmom"

  ];

  // const Paths = [

  // ];

  const isRestrictedRoute = restrictedPaths.includes(location.pathname.toLowerCase());
  const isAdminRoute = location.pathname.startsWith('/admin'); // Check if current route is an admin route

  

  return (
    <> 
       <div className="">
        {isAdminRoute ? (
          // Render Admin layout with sidebar and dashboard for admin routes
          <AdminDashboard />
        ) : (
          <>
            {/* Render Navbar and Footer for non-admin routes */}
            {!isRestrictedRoute && <Navbar />}
            <Routess />
            {!isRestrictedRoute && <Footer />}
          </>
        )}
      </div>
    </>
  );
};

export default App;